/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CreateViewRequest,
  CreateViewResponse,
  EditViewRequest,
  SavedViewDetail,
  SavedViewSummary,
  UpdateViewRequest,
} from "../models/index";
import {
  CreateViewRequestFromJSON,
  CreateViewRequestToJSON,
  CreateViewResponseFromJSON,
  CreateViewResponseToJSON,
  EditViewRequestFromJSON,
  EditViewRequestToJSON,
  SavedViewDetailFromJSON,
  SavedViewDetailToJSON,
  SavedViewSummaryFromJSON,
  SavedViewSummaryToJSON,
  UpdateViewRequestFromJSON,
  UpdateViewRequestToJSON,
} from "../models/index";

export interface CreateViewOperationRequest {
  createViewRequest: CreateViewRequest;
}

export interface DeleteViewRequest {
  savedViewId: string;
}

export interface DuplicateViewRequest {
  savedViewId: string;
}

export interface EditViewOperationRequest {
  editViewRequest: EditViewRequest;
}

export interface FollowViewRequest {
  savedViewId: string;
}

export interface GetViewDetailRequest {
  savedViewId: string;
}

export interface UnfollowViewRequest {
  savedViewId: string;
}

export interface UpdateViewOperationRequest {
  updateViewRequest: UpdateViewRequest;
}

/**
 *
 */
export class SavedViewsApi extends runtime.BaseAPI {
  /**
   */
  async createViewRaw(
    requestParameters: CreateViewOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateViewResponse>> {
    if (requestParameters["createViewRequest"] == null) {
      throw new runtime.RequiredError(
        "createViewRequest",
        'Required parameter "createViewRequest" was null or undefined when calling createView().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/saved-views/create-view`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateViewRequestToJSON(requestParameters["createViewRequest"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateViewResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async createView(
    requestParameters: CreateViewOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateViewResponse> {
    const response = await this.createViewRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async deleteViewRaw(
    requestParameters: DeleteViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters["savedViewId"] == null) {
      throw new runtime.RequiredError(
        "savedViewId",
        'Required parameter "savedViewId" was null or undefined when calling deleteView().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["savedViewId"] != null) {
      queryParameters["savedViewId"] = requestParameters["savedViewId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/saved-views/delete-view`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async deleteView(
    requestParameters: DeleteViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<boolean> {
    const response = await this.deleteViewRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async duplicateViewRaw(
    requestParameters: DuplicateViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateViewResponse>> {
    if (requestParameters["savedViewId"] == null) {
      throw new runtime.RequiredError(
        "savedViewId",
        'Required parameter "savedViewId" was null or undefined when calling duplicateView().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["savedViewId"] != null) {
      queryParameters["savedViewId"] = requestParameters["savedViewId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/saved-views/duplicate-view`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateViewResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async duplicateView(
    requestParameters: DuplicateViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateViewResponse> {
    const response = await this.duplicateViewRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async editViewRaw(
    requestParameters: EditViewOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["editViewRequest"] == null) {
      throw new runtime.RequiredError(
        "editViewRequest",
        'Required parameter "editViewRequest" was null or undefined when calling editView().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/saved-views/edit-view`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EditViewRequestToJSON(requestParameters["editViewRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async editView(
    requestParameters: EditViewOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.editViewRaw(requestParameters, initOverrides);
  }

  /**
   */
  async followViewRaw(
    requestParameters: FollowViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["savedViewId"] == null) {
      throw new runtime.RequiredError(
        "savedViewId",
        'Required parameter "savedViewId" was null or undefined when calling followView().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["savedViewId"] != null) {
      queryParameters["savedViewId"] = requestParameters["savedViewId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/saved-views/follow-view`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async followView(
    requestParameters: FollowViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.followViewRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getAllViewsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<SavedViewSummary>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/saved-views/get-all-views`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SavedViewSummaryFromJSON),
    );
  }

  /**
   */
  async getAllViews(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<SavedViewSummary>> {
    const response = await this.getAllViewsRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getViewDetailRaw(
    requestParameters: GetViewDetailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SavedViewDetail>> {
    if (requestParameters["savedViewId"] == null) {
      throw new runtime.RequiredError(
        "savedViewId",
        'Required parameter "savedViewId" was null or undefined when calling getViewDetail().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["savedViewId"] != null) {
      queryParameters["savedViewId"] = requestParameters["savedViewId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/saved-views/get-view-detail`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SavedViewDetailFromJSON(jsonValue),
    );
  }

  /**
   */
  async getViewDetail(
    requestParameters: GetViewDetailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SavedViewDetail> {
    const response = await this.getViewDetailRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async unfollowViewRaw(
    requestParameters: UnfollowViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["savedViewId"] == null) {
      throw new runtime.RequiredError(
        "savedViewId",
        'Required parameter "savedViewId" was null or undefined when calling unfollowView().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["savedViewId"] != null) {
      queryParameters["savedViewId"] = requestParameters["savedViewId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/saved-views/unfollow-view`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async unfollowView(
    requestParameters: UnfollowViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.unfollowViewRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateViewRaw(
    requestParameters: UpdateViewOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["updateViewRequest"] == null) {
      throw new runtime.RequiredError(
        "updateViewRequest",
        'Required parameter "updateViewRequest" was null or undefined when calling updateView().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/saved-views/update-view`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateViewRequestToJSON(requestParameters["updateViewRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateView(
    requestParameters: UpdateViewOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateViewRaw(requestParameters, initOverrides);
  }
}
